import React from "react";
import {
  Grid2,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
} from "@mui/material";
import styles from "./CurrentSiteInfo.module.scss";
import CustomInput from "../CustomInput/CustomInput";
import { installationTypeMap } from "../../Features/Admin/Pages/CreateSite/Components/ConstantData/CreateSiteConstantData";

export default function CurrentSiteInfo(props) {
  const {
    isCurrentHosting,
    setISCurrentHosting,
    isMultisite,
    setIsMultisite,
    hasImportantDirs,
    setHasImportantDirs,
    isCreateSite,
    onInstallationTypeSelect,
    setInstallationType,
    userDetails,
  } = props;

  const fromFieldUpdate = (value, type) => {
    if (type === "Current Hosting") {
      let trimmedValue = value.replace(/[^a-zA-Z0-9 ]/g, "");
      setISCurrentHosting({
        ...isCurrentHosting,
        currenthostingerror: false,
        currenthosting: trimmedValue,
      });
    } else if (type === "Specify Directory") {
      let trimmedValue = value.replace(/^\s+/, "");
      setISCurrentHosting({
        ...isCurrentHosting,
        specifydirectoryerror: false,
        specifydirectory: trimmedValue,
      });
    }
  };

  return (
    <Grid2 className={styles.CurrentSiteInfo}>
      <Grid2 className={styles.header}>Current site info</Grid2>
      <Grid2 className={styles.MigrationFlexBox}>
        <Grid2 className={styles.CustomInput}>
          <CustomInput
            title="Current Hosting"
            placeholder="Enter your current provider"
            value={isCurrentHosting.currenthosting}
            setValue={(e, name) => {
              fromFieldUpdate(e.replace(/^\s+/, ""), name);
            }}
            error={isCurrentHosting.currenthostingerror}
          />
        </Grid2>

        <Grid2 className={styles.FlexRadio}>
          {isCreateSite && (
            <FormControl>
              <Grid2 className={styles.multisite}>
                Is this a multisite network?
                <RadioGroup
                  row
                  value={isMultisite}
                  onChange={(e) => {
                    const isMulti = e.target.value === "true";
                    setIsMultisite(isMulti);
                    setInstallationType(!isMulti ? 0 : 1);
                    onInstallationTypeSelect(
                      isMulti
                        ? installationTypeMap["Multisite Sub-domain"]
                        : installationTypeMap["Single site"]
                    );
                  }}
                >
                  {[
                    { label: "Yes", value: "true" },
                    { label: "No", value: "false" },
                  ].map((option) => (
                    <FormControlLabel
                      key={option.label}
                      value={option.value}
                      control={<Radio />}
                      label={
                        <span
                          className={
                            isMultisite === (option.value === "true")
                              ? styles.optionColor
                              : styles.optionColor1
                          }
                        >
                          {option.label}
                        </span>
                      }
                      sx={{
                        "& .MuiFormControlLabel-label": {
                          fontSize: "14px",
                          fontWeight: "500",
                          color:
                            isMultisite === (option.value === "true")
                              ? "#135fc2"
                              : userDetails?.theme === "dark"
                              ? "#ffffff"
                              : "#000000",
                        },
                        "& .MuiRadio-root": {
                          fontSize: "14px",
                          fontWeight: "500",
                          color:
                            isMultisite === (option.value === "true")
                              ? "#135fc2"
                              : userDetails?.theme === "dark"
                              ? "#ffffff"
                              : "#000000",
                        },
                      }}
                    />
                  ))}
                </RadioGroup>
              </Grid2>
            </FormControl>
          )}

          <FormControl>
            <Grid2 className={styles.multisite}>
              Are there any important directories in the root?
              <RadioGroup
                row
                value={hasImportantDirs} // Keeps it as true/false
                onChange={(e) => {
                  setHasImportantDirs(e.target.value === "true"); // Convert "true"/"false" string to boolean
                  setISCurrentHosting({
                    ...isCurrentHosting,
                    specifydirectoryerror: false,
                    specifydirectory: "",
                  });
                }}
              >
                {[
                  { label: "Yes", value: "true" },
                  { label: "No", value: "false" },
                ].map((option) => (
                  <FormControlLabel
                    key={option.label}
                    value={option.value}
                    control={<Radio />}
                    label={
                      <span
                        className={
                          hasImportantDirs === (option.value === "true")
                            ? styles.optionColor
                            : styles.optionColor1
                        }
                      >
                        {option.label}
                      </span>
                    }
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        fontSize: "14px",
                        fontWeight: "500",
                        color:
                          hasImportantDirs === (option.value === "true")
                            ? "#135fc2"
                            : userDetails?.theme === "dark"
                            ? "#ffffff"
                            : "#000000",
                      },
                      "& .MuiRadio-root": {
                        fontSize: "14px",
                        fontWeight: "500",
                        color:
                          hasImportantDirs === (option.value === "true")
                            ? "#135fc2"
                            : userDetails?.theme === "dark"
                            ? "#ffffff"
                            : "#000000",
                      },
                    }}
                  />
                ))}
              </RadioGroup>
            </Grid2>
          </FormControl>
        </Grid2>
      </Grid2>
      {isCurrentHosting.currenthosting !== "" && hasImportantDirs === true && (
        <Grid2>
          <CustomInput
            title="Specify Directory"
            placeholder="Enter directory name"
            value={isCurrentHosting.specifydirectory}
            setValue={(e, name) => {
              fromFieldUpdate(e, name);
            }}
            error={isCurrentHosting.specifydirectoryerror}
          />
        </Grid2>
      )}
    </Grid2>
  );
}
